import React, { useState, useEffect, useCallback } from 'react';
import { 
  FaHome, FaChevronRight, FaChevronDown, FaStar, FaCalendarAlt, 
  FaUsers, FaBook, FaPlayCircle, FaLaptop, FaClock, FaFileAlt, 
  FaFilter, FaTimes
} from 'react-icons/fa';

export default function AdvancedCourseNavigation() {
  // State management
  const [activeTab, setActiveTab] = useState('Dropper');
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [showingBatches, setShowingBatches] = useState(0);
  const [activeFilters, setActiveFilters] = useState({
    mode: null,
    batchType: null,
    language: null,
    pricing: null
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  
  // Mock course data
  const courseData = {
    'All Batches': {
      title: "IIT JEE Online Courses in India, JEE Online Coaching",
      description: "PW offers comprehensive IIT-JEE coaching for all classes, including online classes in multiple languages, live and recorded sessions, doubt-solving support, and useful study materials.",
      batches: [
        { id: 1, name: "Complete JEE Foundation", level: "Beginner to Advanced", price: 12999, discount: 9999, students: 15000, language: "English", rating: 4.8, duration: "12 months", mode: "Online", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 2, name: "JEE Master Course", level: "Intermediate to Expert", price: 14999, discount: 11999, students: 12500, language: "Hindi", rating: 4.9, duration: "15 months", mode: "Online", type: "Power Batch", image: "/api/placeholder/300/180" },
        { id: 3, name: "JEE Champions Batch", level: "Advanced", price: 16999, discount: 13999, students: 8000, language: "Hinglish", rating: 4.7, duration: "18 months", mode: "Offline", type: "Newly Launched", image: "/api/placeholder/300/180" },
        { id: 4, name: "JEE Rank Booster", level: "Intermediate", price: 9999, discount: 7999, students: 10000, language: "English", rating: 4.6, duration: "6 months", mode: "Online", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 5, name: "JEE Weekend Program", level: "Beginner to Intermediate", price: 8999, discount: 6999, students: 9500, language: "Hindi", rating: 4.5, duration: "8 months", mode: "Hybrid", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 6, name: "JEE Crash Course", level: "Advanced", price: 7999, discount: 5999, students: 7000, language: "English", rating: 4.4, duration: "3 months", mode: "Online", type: "Power Batch", image: "/api/placeholder/300/180" }
      ]
    },
    'Class 11': {
      title: "Class 11 IIT JEE Online Course in India, JEE Online Coaching For Class 11 Targeting 2025, 26 And 27 Exams",
      description: "PW offers Class 11 IIT-JEE coaching, including online classes in multiple languages, live and recorded sessions, doubt-solving support, and useful study materials. PW ensures a well-rounded preparation for IIT-JEE aspirants.",
      batches: [
        { id: 11, name: "Class 11 Foundation Plus", level: "Beginner to Intermediate", price: 10999, discount: 8999, students: 12000, language: "English", rating: 4.9, duration: "12 months", mode: "Online", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 12, name: "Class 11 Achievers Batch", level: "Intermediate", price: 12999, discount: 9999, students: 9000, language: "Hindi", rating: 4.8, duration: "15 months", mode: "Online", type: "Power Batch", image: "/api/placeholder/300/180" },
        { id: 13, name: "Class 11 Elite Program", level: "Advanced", price: 14999, discount: 11999, students: 7500, language: "Hinglish", rating: 4.7, duration: "12 months", mode: "Offline", type: "Newly Launched", image: "/api/placeholder/300/180" },
        { id: 14, name: "Class 11 Weekend Special", level: "Beginner to Advanced", price: 9999, discount: 7999, students: 8500, language: "English", rating: 4.6, duration: "10 months", mode: "Online", type: "CURIOUS JR", image: "/api/placeholder/300/180" }
      ]
    },
    'Class 12': {
      title: "Class 12 IIT JEE Online Course in India, Complete JEE Main & Advanced Preparation",
      description: "Our Class 12 IIT-JEE program focuses on completing the syllabus while simultaneously preparing students for board exams. Get comprehensive preparation with PW's expert faculty.",
      batches: [
        { id: 21, name: "Class 12 JEE Complete", level: "Intermediate to Advanced", price: 13999, discount: 10999, students: 11000, language: "English", rating: 4.9, duration: "12 months", mode: "Online", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 22, name: "Class 12 Champion Batch", level: "Advanced", price: 15999, discount: 12999, students: 8500, language: "Hindi", rating: 4.8, duration: "14 months", mode: "Online", type: "Power Batch", image: "/api/placeholder/300/180" },
        { id: 23, name: "Class 12 Board + JEE", level: "Intermediate", price: 12999, discount: 9999, students: 9500, language: "Hinglish", rating: 4.7, duration: "10 months", mode: "Offline", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 24, name: "Class 12 Advanced Focus", level: "Advanced", price: 16999, discount: 13999, students: 7000, language: "English", rating: 4.8, duration: "12 months", mode: "Online", type: "Newly Launched", image: "/api/placeholder/300/180" }
      ]
    },
    'Dropper': {
      title: "Dropper Batch for IIT JEE, Complete JEE Preparation for Repeating Students",
      description: "Specially designed for students who are taking a drop year to prepare for JEE, our courses offer intensive training, regular tests, and personalized mentoring to ensure success.",
      batches: [
        { id: 31, name: "Dropper's Intensive", level: "Intermediate to Advanced", price: 15999, discount: 12999, students: 9500, language: "English", rating: 4.9, duration: "11 months", mode: "Online", type: "Regular", image: "/api/placeholder/300/180" },
        { id: 32, name: "One Year Master Program", level: "Advanced", price: 17999, discount: 14999, students: 8000, language: "Hindi", rating: 4.8, duration: "12 months", mode: "Online", type: "Power Batch", image: "/api/placeholder/300/180" },
        { id: 33, name: "Dropper's Rank Booster", level: "Advanced", price: 19999, discount: 16999, students: 7000, language: "English", rating: 4.9, duration: "10 months", mode: "Offline", type: "Power Batch", image: "/api/placeholder/300/180" }
      ]
    }
  };

  // Filter batches based on active filters
  const filterBatches = useCallback(() => {
    if (!courseData[activeTab]) return [];
    
    let batches = [...courseData[activeTab].batches];
    
    if (activeFilters.mode) {
      batches = batches.filter(batch => batch.mode === activeFilters.mode);
    }
    
    if (activeFilters.batchType) {
      batches = batches.filter(batch => batch.type === activeFilters.batchType);
    }
    
    if (activeFilters.language) {
      batches = batches.filter(batch => batch.language === activeFilters.language);
    }
    
    if (activeFilters.pricing === 'lowToHigh') {
      batches.sort((a, b) => a.discount - b.discount);
    } else if (activeFilters.pricing === 'highToLow') {
      batches.sort((a, b) => b.discount - a.discount);
    }
    
    return batches;
  }, [activeTab, activeFilters, courseData]);

  // Update filtered batches whenever filters or active tab changes
  useEffect(() => {
    const batches = filterBatches();
    setFilteredBatches(batches);
    setShowingBatches(batches.length);
  }, [filterBatches]);

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        setShowMobileFilters(false);
      }
    };
    
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  // Handle dropdown toggle
  const toggleDropdown = (dropdown, e) => {
    if (e) e.stopPropagation();
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      if (openDropdown) setOpenDropdown(null);
    };
    
    if (typeof document !== 'undefined') {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [openDropdown]);

  // Handle filter changes
  const handleFilterChange = (filterType, value, e) => {
    if (e) e.stopPropagation();
    setActiveFilters(prev => ({
      ...prev,
      [filterType]: prev[filterType] === value ? null : value
    }));
    setOpenDropdown(null);
  };

  // Reset all filters
  const resetFilters = () => {
    setActiveFilters({
      mode: null,
      batchType: null,
      language: null,
      pricing: null
    });
  };

  // Handle tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Reset filters when changing tabs for better UX
    resetFilters();
  };

  // Get active tab URL path
  const getActiveTabPath = () => {
    switch (activeTab) {
      case 'Class 11':
        return 'class-11';
      case 'Class 12':
        return 'class-12';
      case 'Dropper':
        return 'dropper';
      default:
        return 'all-batches';
    }
  };

  return (
    <div className="flex flex-col w-full bg-gray-50 font-sans">
      {/* Breadcrumb Navigation */}
      <div className="py-3 px-4 md:px-8 flex items-center text-gray-700 text-sm md:text-base bg-white border-b border-gray-100 overflow-x-auto whitespace-nowrap shadow-sm">
        <a href="/" className="flex items-center hover:text-purple-600 transition-colors duration-300">
          <FaHome className="text-lg text-purple-600" />
        </a>
        <FaChevronRight className="mx-2 text-gray-400" />
        <a href="/iit-jee" className="hover:text-purple-600 transition-colors duration-300">
          IIT JEE
        </a>
        <FaChevronRight className="mx-2 text-gray-400" />
        <a href={`/iit-jee/${getActiveTabPath()}`} className="hover:text-purple-600 transition-colors duration-300">
          {activeTab}
        </a>
        <FaChevronRight className="mx-2 text-gray-400" />
        <span className="font-semibold text-gray-900">BATCHES</span>
      </div>

      {/* Main Heading */}
      <div className="px-4 md:px-8 py-8 bg-white shadow-sm">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 leading-tight">
            {courseData[activeTab]?.title || "IIT JEE Online Courses"}
          </h1>
          <p className="text-sm md:text-base mt-4 text-gray-600 max-w-4xl">
            {courseData[activeTab]?.description || "Loading description..."}
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="w-full bg-white sticky top-0 z-30 shadow-md border-b border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="flex overflow-x-auto scrollbar-hide">
            {Object.keys(courseData).map((tab) => (
              <div className="relative" key={tab}>
                <button 
                  className={`px-5 sm:px-8 py-4 font-medium text-base relative transition-all duration-300 ${
                    activeTab === tab 
                      ? 'text-purple-700 border-b-2 border-purple-700 bg-purple-50' 
                      : 'text-gray-600 hover:text-purple-600 hover:bg-purple-50'
                  }`}
                  onClick={() => handleTabChange(tab)}
                >
                  {tab}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Filter Toggle */}
      <div className="md:hidden p-4 bg-white shadow-sm">
        <button 
          onClick={() => setShowMobileFilters(!showMobileFilters)}
          className="flex items-center justify-between w-full py-3 px-4 rounded-lg bg-purple-50 text-purple-700 border border-purple-200 shadow-sm hover:bg-purple-100 transition-colors duration-300"
        >
          <div className="flex items-center">
            <FaFilter className="mr-2" />
            <span className="font-medium">Filters</span>
            {Object.values(activeFilters).some(filter => filter !== null) && (
              <span className="ml-2 bg-purple-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {Object.values(activeFilters).filter(filter => filter !== null).length}
              </span>
            )}
          </div>
          <FaChevronDown className={`transform transition-transform duration-300 ${showMobileFilters ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {/* Filter Options - Desktop and Mobile */}
      <div className={`${showMobileFilters ? 'block' : 'hidden md:block'} p-4 md:p-6 bg-white shadow-sm border-t border-b border-gray-100`}>
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-3">
            {/* Mode Filter */}
            <button 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                activeFilters.mode === 'Online' 
                  ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                  : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
              }`}
              onClick={(e) => handleFilterChange('mode', 'Online', e)}
            >
              <FaLaptop className="mr-2" /> Online
            </button>
            
            <button 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                activeFilters.mode === 'Offline' 
                  ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                  : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
              }`}
              onClick={(e) => handleFilterChange('mode', 'Offline', e)}
            >
              <FaUsers className="mr-2" /> Offline
            </button>
            
            {/* Pricing Dropdown */}
            <div className="relative">
              <button 
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                  activeFilters.pricing 
                    ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
                }`}
                onClick={(e) => toggleDropdown('pricing', e)}
              >
                Pricing <FaChevronDown className={`ml-2 transform transition-transform duration-300 ${openDropdown === 'pricing' ? 'rotate-180' : ''}`} />
              </button>
              
              {openDropdown === 'pricing' && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-20 py-2 border border-gray-200 animate-fadeIn">
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer flex items-center transition-colors duration-300 ${
                      activeFilters.pricing === 'lowToHigh' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'
                    }`}
                    onClick={(e) => handleFilterChange('pricing', 'lowToHigh', e)}
                  >
                    <span className="mr-2">↑</span> Low to High
                  </div>
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer flex items-center transition-colors duration-300 ${
                      activeFilters.pricing === 'highToLow' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'
                    }`}
                    onClick={(e) => handleFilterChange('pricing', 'highToLow', e)}
                  >
                    <span className="mr-2">↓</span> High to Low
                  </div>
                </div>
              )}
            </div>
            
            {/* Language Dropdown */}
            <div className="relative">
              <button 
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                  activeFilters.language 
                    ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                    : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
                }`}
                onClick={(e) => toggleDropdown('language', e)}
              >
                Language <FaChevronDown className={`ml-2 transform transition-transform duration-300 ${openDropdown === 'language' ? 'rotate-180' : ''}`} />
              </button>
              
              {openDropdown === 'language' && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-20 py-2 border border-gray-200 animate-fadeIn">
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer transition-colors duration-300 ${
                      activeFilters.language === 'English' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'
                    }`}
                    onClick={(e) => handleFilterChange('language', 'English', e)}
                  >
                    English
                  </div>
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer transition-colors duration-300 ${
                      activeFilters.language === 'Hindi' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'
                    }`}
                    onClick={(e) => handleFilterChange('language', 'Hindi', e)}
                  >
                    Hindi
                  </div>
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer transition-colors duration-300 ${
                      activeFilters.language === 'Hinglish' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'
                    }`}
                    onClick={(e) => handleFilterChange('language', 'Hinglish', e)}
                  >
                    Hinglish
                  </div>
                </div>
              )}
            </div>
            
            {/* Batch Type Filters */}
            <button 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                activeFilters.batchType === 'Power Batch' 
                  ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                  : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
              }`}
              onClick={(e) => handleFilterChange('batchType', 'Power Batch', e)}
            >
              <FaBook className="mr-2" /> Power Batch
            </button>
            
            <button 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                activeFilters.batchType === 'Newly Launched' 
                  ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                  : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
              }`}
              onClick={(e) => handleFilterChange('batchType', 'Newly Launched', e)}
            >
              <FaStar className="mr-2" /> Newly Launched
            </button>
            
            <button 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                activeFilters.batchType === 'CURIOUS JR' 
                  ? 'bg-purple-100 text-purple-700 border border-purple-300 shadow-sm' 
                  : 'bg-white border border-gray-300 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600'
              }`}
              onClick={(e) => handleFilterChange('batchType', 'CURIOUS JR', e)}
            >
              <FaPlayCircle className="mr-2" /> CURIOUS JR
            </button>
            
            {/* Reset Filters Button - only show if filters are active */}
            {Object.values(activeFilters).some(filter => filter !== null) && (
              <button 
                className="px-4 py-2 rounded-full text-sm font-medium flex items-center ml-auto bg-gray-200 text-gray-800 hover:bg-gray-300 transition-all duration-300"
                onClick={resetFilters}
              >
                <FaTimes className="mr-1" /> Reset All
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Batch Count */}
      <div className="px-4 md:px-8 py-4 bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <p className="text-gray-800 font-medium">
            Showing <span className="font-bold text-purple-700">{showingBatches}</span> Total Batches
          </p>
          
          {/* Sorting for Mobile - could be expanded further */}
          {windowWidth <= 768 && (
            <div className="relative">
              <button 
                className="flex items-center text-sm text-purple-700 font-medium"
                onClick={(e) => toggleDropdown('mobileSorting', e)}
              >
                Sort By <FaChevronDown className="ml-1" />
              </button>
              
              {openDropdown === 'mobileSorting' && (
                <div className="absolute top-full right-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-20 py-2 border border-gray-200 animate-fadeIn">
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer transition-colors duration-300 ${activeFilters.pricing === 'lowToHigh' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'}`}
                    onClick={(e) => handleFilterChange('pricing', 'lowToHigh', e)}
                  >
                    Price: Low to High
                  </div>
                  <div 
                    className={`px-4 py-2 hover:bg-purple-50 cursor-pointer transition-colors duration-300 ${activeFilters.pricing === 'highToLow' ? 'text-purple-700 font-medium bg-purple-50' : 'text-gray-700'}`}
                    onClick={(e) => handleFilterChange('pricing', 'highToLow', e)}
                  >
                    Price: High to Low
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Course Cards */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredBatches.map((batch) => (
            <div 
              key={batch.id}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:-translate-y-2"
            >
              <div className="relative">
                <img 
                  src={batch.image} 
                  alt={batch.name} 
                  className="w-full h-48 object-cover"
                />
                {batch.type && (
                  <div className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-bold ${
                    batch.type === 'Power Batch' ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-md' : 
                    batch.type === 'Newly Launched' ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-md' :
                    batch.type === 'CURIOUS JR' ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md' :
                    'bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-md'
                  }`}>
                    {batch.type}
                  </div>
                )}
                <div className="absolute bottom-3 right-3 bg-black bg-opacity-60 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs flex items-center shadow-md">
                  <FaUsers className="mr-1" /> {batch.students.toLocaleString()}+ students
                </div>
              </div>
              
              <div className="p-5">
                <div className="flex items-center mb-3">
                  <div className="flex items-center bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs font-medium">
                    <FaStar className="text-yellow-500 mr-1" /> {batch.rating}
                  </div>
                  <span className="text-xs text-gray-500 ml-2">({Math.floor(batch.students/100)}+ reviews)</span>
                </div>
                
                <h3 className="font-bold text-lg text-gray-900 mb-1 line-clamp-2">{batch.name}</h3>
                <p className="text-sm text-gray-600 mb-4">{batch.level}</p>
                
                <div className="flex flex-wrap gap-2 mb-5">
                  <div className="bg-gray-100 text-gray-700 rounded-full px-3 py-1 text-xs flex items-center hover:bg-gray-200 transition-colors duration-300">
                    <FaClock className="mr-1 text-gray-500" /> {batch.duration}
                  </div>
                  <div className="bg-gray-100 text-gray-700 rounded-full px-3 py-1 text-xs flex items-center hover:bg-gray-200 transition-colors duration-300">
                    <FaClock className="mr-1 text-gray-500" /> {batch.duration}
                  </div>
                  <div className="bg-gray-100 text-gray-700 rounded-full px-3 py-1 text-xs flex items-center hover:bg-gray-200 transition-colors duration-300">
                    <FaLaptop className="mr-1 text-gray-500" /> {batch.mode}
                  </div>
                  <div className="bg-gray-100 text-gray-700 rounded-full px-3 py-1 text-xs flex items-center hover:bg-gray-200 transition-colors duration-300">
                    <FaFileAlt className="mr-1 text-gray-500" /> {batch.language}
                  </div>
                </div>
                
                <div className="flex justify-between items-end">
                  <div>
                    <div className="flex items-center">
                      <span className="text-lg font-bold text-purple-700">₹{batch.discount.toLocaleString()}</span>
                      <span className="ml-2 text-sm text-gray-500 line-through">₹{batch.price.toLocaleString()}</span>
                    </div>
                    <p className="text-xs text-green-600 font-medium">
                      Save ₹{(batch.price - batch.discount).toLocaleString()}
                    </p>
                  </div>
                  
                  <button className="px-4 py-2 bg-purple-600 text-white rounded-lg text-sm font-medium hover:bg-purple-700 transition-colors duration-300 shadow-md hover:shadow-lg">
                    Enroll Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredBatches.length === 0 && (
          <div className="bg-white rounded-xl p-8 shadow-md text-center">
            <div className="flex justify-center mb-4">
              <FaFilter className="text-4xl text-gray-400" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">No Batches Found</h3>
            <p className="text-gray-600 mb-4">We couldn't find any batches matching your current filters.</p>
            <button 
              onClick={resetFilters}
              className="px-6 py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors duration-300"
            >
              Reset All Filters
            </button>
          </div>
        )}
      </div>

      {/* Footer - Just a simple one for completeness */}
      <div className="bg-gray-50 border-t border-gray-200 py-8 mt-8">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="text-center">
            <h3 className="text-lg font-bold text-gray-800 mb-4">Need Help Choosing the Right Course?</h3>
            <p className="text-gray-600 mb-6">Our education counselors are here to guide you on your learning journey</p>
            <button className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors duration-300 shadow-lg">
              Book a Free Consultation
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Filter Overlay Background */}
      {showMobileFilters && windowWidth <= 768 && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={() => setShowMobileFilters(false)}
        />
      )}

      {/* CSS Animation Classes */}
      <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-in-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}